var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// packages/remirror__extension-count/src/count-extension.ts
import { extension, findMatches as findMatches2, helper, PlainExtension } from "@remirror/core";
import { Plugin } from "@remirror/pm/state";
import { Decoration, DecorationSet } from "@remirror/pm/view";

// packages/remirror__extension-count/src/count-utils.ts
import { findMatches } from "@remirror/core";
var WORDS_REGEX = /\S+/g;
function getTextLength(node) {
  if (node.type.isTextblock) {
    return 1;
  }
  if (node.type.isText) {
    return node.textBetween(0, node.nodeSize).length;
  }
  return 0;
}
function getCharacterExceededPosition({ doc }, maxCharacters) {
  let count = 0;
  let foundPos = 0;
  doc.nodesBetween(0, doc.nodeSize - 2, (node, pos) => {
    if (foundPos > 0) {
      return false;
    }
    const nodeTextLength = getTextLength(node);
    if (count + nodeTextLength > maxCharacters) {
      foundPos = pos + 1 + (maxCharacters - count);
      return false;
    }
    count += nodeTextLength;
    return true;
  });
  return foundPos;
}
function getWordExceededPosition({ doc }, maxWords) {
  let count = 0;
  let foundPos = 0;
  doc.nodesBetween(0, doc.nodeSize - 2, (node, pos) => {
    if (foundPos > 0) {
      return false;
    }
    if (!node.type.isText) {
      return true;
    }
    const text = node.textBetween(0, node.nodeSize);
    const matches = findMatches(text, WORDS_REGEX);
    if (count + matches.length > maxWords) {
      const index = maxWords - count;
      const word = matches[index];
      foundPos = pos + ((word == null ? void 0 : word.index) ?? 0);
      return false;
    }
    count += matches.length;
    return true;
  });
  return foundPos;
}

// packages/remirror__extension-count/src/count-extension.ts
var CountStrategy = /* @__PURE__ */ ((CountStrategy2) => {
  CountStrategy2["CHARACTERS"] = "CHARACTERS";
  CountStrategy2["WORDS"] = "WORDS";
  return CountStrategy2;
})(CountStrategy || {});
var CountExtension = class extends PlainExtension {
  get name() {
    return "count";
  }
  getCountMaximum() {
    return this.options.maximum;
  }
  getCharacterCount(state = this.store.getState()) {
    let count = 0;
    state.doc.nodesBetween(0, state.doc.nodeSize - 2, (node) => {
      count += getTextLength(node);
      return true;
    });
    return Math.max(count - 1, 0);
  }
  getWordCount(state = this.store.getState()) {
    const text = this.store.helpers.getText({ lineBreakDivider: " ", state });
    return findMatches2(text, WORDS_REGEX).length;
  }
  isCountValid(state = this.store.getState()) {
    const { maximumStrategy, maximum } = this.options;
    if (maximum < 1) {
      return true;
    }
    if (maximumStrategy === "CHARACTERS" /* CHARACTERS */) {
      const count = this.store.helpers.getCharacterCount(state);
      return count <= maximum;
    }
    return this.store.helpers.getWordCount(state) <= maximum;
  }
  createDecorationSet(state) {
    const { maximum = -1, maximumStrategy, maximumExceededClassName } = this.options;
    const isCharacterCountStrategy = maximumStrategy === "CHARACTERS" /* CHARACTERS */;
    const posStrategy = isCharacterCountStrategy ? getCharacterExceededPosition : getWordExceededPosition;
    const pos = posStrategy(state, maximum);
    return DecorationSet.create(state.doc, [
      Decoration.inline(pos, state.doc.nodeSize - 2, {
        class: maximumExceededClassName
      })
    ]);
  }
  createExternalPlugins() {
    const { maximum } = this.options;
    const plugin = new Plugin({
      state: {
        init: (_, state) => {
          if (this.isCountValid(state)) {
            return {
              decorationSet: DecorationSet.empty
            };
          }
          return {
            decorationSet: this.createDecorationSet(state)
          };
        },
        apply: (tr, pluginState, _, state) => {
          if (!tr.docChanged || maximum < 1) {
            return pluginState;
          }
          if (this.isCountValid(state)) {
            return {
              decorationSet: DecorationSet.empty
            };
          }
          return {
            decorationSet: this.createDecorationSet(state)
          };
        }
      },
      props: {
        decorations(state) {
          var _a;
          return ((_a = plugin.getState(state)) == null ? void 0 : _a.decorationSet) ?? null;
        }
      }
    });
    return [plugin];
  }
};
__decorateClass([
  helper()
], CountExtension.prototype, "getCountMaximum", 1);
__decorateClass([
  helper()
], CountExtension.prototype, "getCharacterCount", 1);
__decorateClass([
  helper()
], CountExtension.prototype, "getWordCount", 1);
__decorateClass([
  helper()
], CountExtension.prototype, "isCountValid", 1);
CountExtension = __decorateClass([
  extension({
    defaultOptions: {
      maximum: -1,
      maximumExceededClassName: "remirror-max-count-exceeded",
      maximumStrategy: "CHARACTERS" /* CHARACTERS */
    },
    staticKeys: ["maximum", "maximumStrategy", "maximumExceededClassName"]
  })
], CountExtension);
export {
  CountExtension,
  CountStrategy
};
